/** 邮箱验证码发送冷却秒数（与后端 Redis 限流一致） */
export const EMAIL_CODE_COOLDOWN_SEC = 60

/**
 * 启动发送验证码倒计时；结束后执行 onExpire（通常用于刷新图形验证码）。
 * @param {{ value: number }} cooldownRef - ref 或 Vue2 data 包装
 * @param {{ current: ReturnType<typeof setInterval> | null }} timerHolder
 * @param {() => void} [onExpire]
 */
export function startEmailCodeCooldown(cooldownRef, timerHolder, onExpire) {
  cooldownRef.value = EMAIL_CODE_COOLDOWN_SEC
  if (timerHolder.current) {
    clearInterval(timerHolder.current)
  }
  timerHolder.current = setInterval(() => {
    cooldownRef.value -= 1
    if (cooldownRef.value <= 0) {
      clearInterval(timerHolder.current)
      timerHolder.current = null
      if (typeof onExpire === 'function') {
        onExpire()
      }
    }
  }, 1000)
}

/** Vue2 Options API：在组件 data 上使用 this.codeCooldown */
export function startEmailCodeCooldownVue2(vm, timerKey = '_codeTimer', cooldownKey = 'codeCooldown', onExpire) {
  vm[cooldownKey] = EMAIL_CODE_COOLDOWN_SEC
  if (vm[timerKey]) {
    clearInterval(vm[timerKey])
  }
  vm[timerKey] = setInterval(() => {
    vm[cooldownKey] -= 1
    if (vm[cooldownKey] <= 0) {
      clearInterval(vm[timerKey])
      vm[timerKey] = null
      if (typeof onExpire === 'function') {
        onExpire()
      }
    }
  }, 1000)
}
